import type { Session, UserData } from '@cobliteam/common-types';

/**
 * userData mínimo para o boot de uma sessão de frota inativa: sem `basic:permission`, os
 * resolvers do `getUserData` falham no bouncer e a página de boletos não pode depender deles.
 * Derivado só da sessão; se o `getUserData` resolver depois, o dado real substitui este fallback.
 */
const getInactiveFleetFallbackUserData = (session: Session): UserData => ({
  hasCameraFlag: false,
  hasRedeCan: false,
  vehicleGroups: [],
  userPreferences: undefined,
  userAttributes: { numberOfDevices: 0, creationDate: 0, ageInDays: 0 },
  userFleets: [session.fleet],
});

export default getInactiveFleetFallbackUserData;
